import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer, EuiButton } from "@elastic/eui";
import NavButtons from "components/Outdoor_Cameras/IN-9820_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};